module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Sensory-Overload-Spotting-Signs-Stress-Relief.7503d58c.png";